import { IconMoon, IconSun, IconUserCircle } from '@tabler/icons-react';
import { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Container,
  Dropdown,
  DropdownDivider,
  Nav,
  Navbar,
  Popover,
} from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { profile_menu, is_dark_mode, user_details } from '../themeConfig';
import { getRandomColor, createImageFromInitials } from '../Utils';
import Avatar from './Avatar';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ContactDirectory } from './ContactDirectory';
import { IconAddressBook } from '@tabler/icons-react';
import { IconBell } from '@tabler/icons-react';
import * as NotifApi from '../api/NotifApi';

import Profile from './Profile';
import moment from 'moment';
import { NotificationPopover } from './NotificationPopover';

const Header = () => {
  const authSelector = useSelector((state) => state.rrb.authUserReducer);
  const role = authSelector?.role?.slug;

  const isSidebarVisible = useSelector(
    (state) => state.rrb.sidebarReducer.isVisible
  );
  const navigate = useNavigate();
  // const HEADER_COLOR = process.env.REACT_APP_HEADER_COLOR;
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('mode') === null) {
      localStorage.setItem('mode', is_dark_mode == true ? 'light' : 'light');
    }
  }, []);

  const [darkMode, setDarkMode] = useState(
    localStorage.getItem('mode') == 'light' ? true : false
  );

  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(!darkMode);
    // Update the data-bs-theme attribute in index.html
    const themeAttribute = newDarkMode ? 'light' : 'light';
    document.documentElement.setAttribute('data-bs-theme', themeAttribute);
    localStorage.setItem('mode', themeAttribute);
    // Update the data-bs-theme attribute when component mounts
  };
  const logout = () => {
    navigate('/logout');
  };
  useEffect(() => {
    document.documentElement.setAttribute(
      'data-bs-theme',
      darkMode ? 'light' : 'dark'
    );
  }, [darkMode]);
  const [showProfile, setShowProfile] = useState(false);

  const [notifications, setNotifications] = useState([]);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const [notificationModal, setNotificationModal] = useState(false);

  const allNotifFilter = {
    _page: 1,
    _limit: 10000,
    q: '',
  };

  const getAllReceivedNotif = useCallback(async () => {
    try {
      await NotifApi.getAllReceivedNotif(allNotifFilter).then(({ data }) => {
        if (data?.records !== undefined && data.totalRecords !== null) {
          setNotifications(data?.records);
        }
      });
    } catch (error) {
      console.log('error in getting notification counts', error);
    }
  }, []);

  const getAllUnreadNotifCount = useCallback(async () => {
    try {
      await NotifApi.getUnReadNotifCount().then(({ data }) => {
        if (data?.new !== undefined && data?.new !== null) {
          setUnreadNotificationCount(data.new);
        }
      });
    } catch (error) {
      console.log('error in getting unread notification counts', error);
    }
  });

  useEffect(() => {
    getAllReceivedNotif();
    getAllUnreadNotifCount();
  }, []);

  const markAsRead = async (id) => {
    try {
      await NotifApi.readNotif({ notification_id: id }).then(() => {
        setUnreadNotificationCount(0);
      });
    } catch (error) {
      console.log('error in marking as read', error);
    }
  };

  return (
    <Navbar
      as='header'
      expand='md'
      className={`d-none d-lg-flex d-print-none sticky-top border-bottom ${
        isSidebarVisible ? '' : 'hide'
      } `}
    >
      <Container fluid>
        <Nav className='flex-row order-md-last'>
          <Nav className='d-none d-md-flex'>
            <>
              <Dropdown className='nav-link cursor-pointer'>
                {/* <div className='me-3'>
                  {darkMode ? (
                    <IconSun onClick={toggleDarkMode} />
                  ) : (
                    <IconMoon onClick={toggleDarkMode} />
                  )}
                </div> */}
                {/* <div className='me-4'>
                  <div className='position-relative'> */}
                {/* <Button
                      variant='primary'
                      className='rounded-circle d-flex justify-content-center align-items-center position-relative'
                      style={{ padding: '0.316rem' }}
                      > */}
                {/* {role !== 'super-admin' && (
                      <IconBell onClick={() => setNotificationModal(true)} />
                    )} */}
                {/* <div>
                      {unreadNotificationCount > 0 && (
                        <div
                          className='position-absolute'
                          style={{ bottom: '30px', right: '-5px' }}
                        >
                          <span className='badge rounded-5 bg-danger fs-12'>
                            {unreadNotificationCount}
                          </span>
                        </div>
                      )}
                    </div> */}
                {/* </Button> */}
                {/* </div>
                  {notificationModal && (
                    <div
                      className='position-absolute'
                      style={{ right: '230px' }}
                    >
                      <Popover
                        placement='right'
                        className='mt-2'
                        style={{
                          '--tblr-popover-arrow-width': '0',
                          '--tblr-popover-arrow-height': '0',
                          minWidth: '450px',
                        }}
                      >
                        <Popover.Header className='d-flex justify-content-between align-items-center'>
                          <span className='fs-2'>Notifications</span>
                          <button
                            type='button'
                            className='btn-close'
                            aria-label='Close'
                            onClick={() => setNotificationModal(false)}
                          />
                        </Popover.Header> */}

                {/* <Popover.Body className='p-0'>
                          {notifications && notifications?.length > 0 ? (
                            <div>
                              <div
                                style={{
                                  maxHeight: '300px',
                                  overflow: 'scroll',
                                }}
                              >
                                {notifications?.length > 0 &&
                                  notifications.map((noti, index) => {
                                    const isLastItem =
                                      index === notifications.length - 1;
                                    const avatarLetter = noti.sentBy.first_name
                                      ? noti.sentBy.first_name
                                          .charAt(0)
                                          .toUpperCase()
                                      : '';
                                    const isRead = !noti?.is_read;

                                    return (
                                      <div
                                        key={noti.id}
                                        className=''
                                        style={
                                          isRead
                                            ? {
                                                color: '#2F2F8F',
                                                boxShadow:
                                                  '0px 0px 10px 0px #0000001A',
                                                background: '#F8F8FB',
                                                cursor: 'pointer',
                                              }
                                            : {} */}
                {/* }
                                        onClick={() => {
                                          if (isRead) {
                                            markAsRead(noti.id);
                                            getAllReceivedNotif();
                                          }
                                          setNotificationModal(false);
                                          navigate('/notifications');
                                        }}
                                      >
                                        <div
                                          className='d-flex px-3'
                                          style={{
                                            paddingTop: '12px',
                                            paddingBottom: '12px',
                                          }}
                                        >
                                          <div className='d-flex align-items-start'>
                                            <span
                                              style={{
                                                width: '36px',
                                                height: '36px',
                                              }}
                                              className='avatar rounded-circle text-uppercase text-white bg-primary me-2 fw-bold fs-2'
                                            >
                                              {avatarLetter}
                                            </span>
                                          </div>
                                          <div className='w-100'>
                                            <div
                                              className='fs-3 fw-medium'
                                              // styles={{ marginTop: '5px' }}
                                            >
                                              {noti.title}
                                            </div>
                                            <div
                                              className='fs-4 text-muted fw-normal'
                                              style={{ lineHeight: '18px' }}
                                            > */}
                {/* {noti.description}
                                            </div>
                                            <div className='d-flex justify-content-between align-items-center mt-1'>
                                              <div className='fs-4'>
                                                Sent By:{' '}
                                                <span className='fw-medium'>
                                                  {noti.sentBy.first_name}
                                                </span>
                                              </div>
                                              <div className='small text-muted fw-normal fs-4'>
                                                {moment(noti.created_at).format(
                                                  'DD/MM/YYYY, HH:mm'
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div> */}

                {/* Show separator only if it's NOT the last item */}
                {/* {!isLastItem && (
                                          <div className='hr m-0'></div>
                                        )}
                                      </div>
                                    );
                                  })}
                              </div> */}

                {/* <div
                                className='bg-white m-0 p-2 position-static'
                                style={{
                                  borderBottomLeftRadius: '5px',
                                  borderBottomRightRadius: '5px',
                                  boxShadow: '0px 0px 10px 0px #0000001A',
                                  background: '#F8F8FB',
                                }}
                              >
                                <h3
                                  className='m-0 text-center'
                                  onClick={() => {
                                    setNotificationModal(false);
                                    navigate('/notifications');
                                  }}
                                >
                                  View all
                                </h3>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <h3 className='text-muted text-center mt-3'>
                                No notifications yet
                              </h3>
                            </div>
                          )}
                        </Popover.Body>
                      </Popover>
                    </div>
                  )} */}
                {/* </div> */}
                <NotificationPopover
                  setNotificationModal={setNotificationModal}
                  role={role}
                  unreadNotificationCount={unreadNotificationCount}
                  notificationModal={notificationModal}
                  notifications={notifications}
                  markAsRead={markAsRead}
                  getAllReceivedNotif={getAllReceivedNotif}
                />
                <div className='me-4'>
                  {/* <Button
                    variant='primary'
                    className='rounded-circle d-flex justify-content-center align-items-center'
                    style={{ padding: '0.316rem' }}
                    > */}
                  <IconAddressBook onClick={() => setModalShow(true)} />
                  {/* </Button> */}
                  <ContactDirectory
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                  />
                </div>
                <Dropdown.Toggle
                  as={'a'}
                  bsPrefix={`nav-link d-flex lh-1 text-reset p-0 dropdown-toggle arrow-top`}
                >
                  <Avatar
                    name={authSelector.first_name}
                    profilePicture={user_details.profile_picture}
                  ></Avatar>

                  <div className='d-none d-xl-block px-2'>
                    <div className='fs-3'>
                      {authSelector.first_name} {authSelector.last_name}
                    </div>
                    <div className='mt-1 small text-muted'>
                      {authSelector.role.name}
                    </div>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  align='end'
                  className='dropdown-menu-end dropdown-menu-arrow'
                >
                  {profile_menu.map((item, i) => {
                    if (item.slug === 'logout') {
                      return (
                        <div>
                          <Dropdown.Item
                            key={item.slug}
                            onClick={() => setShowProfile(true)}
                          >
                            <IconUserCircle className='icon me-2' /> Profile
                          </Dropdown.Item>
                          <Dropdown.Item key={item.slug} onClick={logout}>
                            {item.icon}
                            {item.name}
                          </Dropdown.Item>
                        </div>
                      );
                    }
                    return (
                      <Dropdown.Item
                        key={`dd-${i}`}
                        as={NavLink}
                        to={item.slug}
                      >
                        {item.icon}
                        {item.name}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </>
          </Nav>
        </Nav>
        {showProfile && (
          <Profile
            myProfileModal={showProfile}
            setMyProfileModal={setShowProfile}
          />
        )}
        <Navbar.Collapse></Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
